import { Component, Input } from '@angular/core';

@Component({
  selector: 'csa-progress-save-spinner',
  templateUrl: './progress-save-spinner.component.html',
  styleUrls: ['./progress-save-spinner.component.scss'],
  standalone: false,
})
export class ProgressSaveSpinnerComponent {
  @Input() size = 40;
  @Input() strokeWidth = 10;
  @Input() centered: boolean;
  color = '#f9ae05';
  mode = 'indeterminate';

  getMargin(): any {
    return this.centered ? 'auto' : 0;
  }
}
